import React, { useContext } from 'react';

import { ConfigContext } from '../../../context';
import { useDeviceType } from '../../../hooks';

const Address = dealer => {
  const { config, itemPropMap } = useContext(ConfigContext);
  const { isMobile } = useDeviceType();

  const dealerFields = config.addressFields.filter(
    field => dealer[field] !== ''
  );
  let lastField;

  // Japan has different way to write the address, don't show commas and add line break after zipcode
  const isJp = document.body.dataset.language === 'jp_JP';

  return (
    <>
      {dealerFields.map((field, fieldIndex) => {
        const showComma = fieldIndex > 0 && lastField !== 'streetaddress';
        const itemProp = field in itemPropMap ? itemPropMap[field] : '';

        lastField = field;

        if(dealer[field] === '') {
          return null;
        }

        if(isJp) {
          return (
            <React.Fragment key={dealer.slug + field}>
              <span itemProp={itemProp}>{dealer[field]}</span>
              {field ==='zipcode' ? <br /> : null}
            </React.Fragment>
          )
        }

        if(isMobile) {
          return (
            <React.Fragment key={dealer.slug + field}>
              {fieldIndex > 0 ? ', ' : null}
              <span itemProp={itemProp}>{dealer[field]}</span>
            </React.Fragment>
          )
        }

        return (
          <React.Fragment key={dealer.slug + field}>
            {showComma ? ', ' : null}
            <span itemProp={itemProp}>{dealer[field]}</span>
            {field === 'streetaddress' ? <br /> : null}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default Address;
